import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  RemoteParticipantsState,
  AddRemoteParticipantData,
  UpdateRemoteParticipantData,
} from "./types";

/** Store data about the currently connected remote participants. */
export const remoteParticipants = createSlice({
  name: "remoteParticipants",
  initialState: {
    participants: [],
  } as RemoteParticipantsState,
  reducers: {
    addRemoteParticipant: (
      state,
      { payload }: PayloadAction<AddRemoteParticipantData>
    ) => {
      state.participants = [
        ...state.participants,
        {
          isSharingScreen: false,
          audioIsEnabled: false,
          videoIsEnabled: false,
          ...payload,
        },
      ];
    },
    removeRemoteParticipant: (state, { payload }: PayloadAction<string>) => {
      state.participants = state.participants.filter((p) => p.sid !== payload);
    },
    updateRemoteParticipant: (
      state,
      { payload }: PayloadAction<UpdateRemoteParticipantData>
    ) => {
      state.participants = state.participants.map((p) => {
        if (p.sid !== payload.sid) {
          return p;
        }

        return {
          ...p,
          ...payload,
        };
      });
    },
    clearRemoteParticipants: (state) => {
      state.participants = [];
    },
    toggleMuteAllParticipants: (state) => {
      state.muteAll = !state.muteAll;
    },
  },
});

export const {
  addRemoteParticipant,
  removeRemoteParticipant,
  updateRemoteParticipant,
  clearRemoteParticipants,
  toggleMuteAllParticipants,
} = remoteParticipants.actions;

export default remoteParticipants.reducer;
